// UK postcode pattern regex, takes the GIR (Bootle) non-geographic postcode into account
const postcodeRegex:RegExp =/^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/gmi;

export function validatePostcode(postcode: string):boolean {
    const matchingPattern = postcode.match(postcodeRegex);
    return matchingPattern && matchingPattern.length > 0 ? true : false;
}

export const checkPath = (search: string) => {
    //if path is NOT empty string, return full path
    return search && `/${search}`
  }